import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refTechnicalServiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'serial_number', label: 'Ürün Seri No', sortable: true },
    { key: 'title', label: 'Başlık', sortable: true },
    { key: 'description', label: 'Açıklama', sortable: true },
    { key: 'accept_date', label: 'Alınma Zamanı', sortable: true },
    { key: 'transaction', label: 'İşlem', sortable: true },
    { key: 'status', label: 'Durum', sortable: true },
    { key: 'actions', label: '' },
  ]
  const perPage = ref(10)
  const totalTechnicalServiceData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refTechnicalServiceListTable.value ? refTechnicalServiceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTechnicalServiceData.value,
    }
  })

  const refetchData = () => {
    refTechnicalServiceListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchTechnicalServiceDatas = (ctx, callback) => {
    store
      .dispatch('app-technical-service/fetchTechnicalServiceDatas', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data } = response.data
        const { total } = response.data.meta

        callback(data)
        totalTechnicalServiceData.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching technical service list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchTechnicalServiceDatas,
    tableColumns,
    perPage,
    currentPage,
    totalTechnicalServiceData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTechnicalServiceListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
